import { memo, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useQuery } from 'react-query';

import useAxiosPrivate from 'hooks/useAxiosPrivate';
import CurrencyFormat from 'components/ui/text-formats/CurrencyFormat';

const ProductStatistics = () => {
  const axiosPrivate = useAxiosPrivate();
  const [searchParams] = useSearchParams();
  const [hasError, setHasError] = useState(false);

  const warehouseId = searchParams.get('warehouse_id');

  const { isLoading, isFetching, isError, data } = useQuery({
    queryKey: ['analytic/warehouse/stockDetails/{warehouse_id}', warehouseId],
    queryFn: async function () {
      const response = await axiosPrivate.get(
        `/analytic/warehouse/stockDetails/${warehouseId}`
      );
      return response.data.data;
    },

    enabled: !!warehouseId && !hasError,
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  return (
    <div className='residential-complex-item income-by-residential-complex !shadow-md !base-border'>
      <div className='residential-complex-item-header'>
        <div className='residential-complex-item-title font-semibold text-lg income-by-residential-complex-title mb-4'>
          Ombordagi mahsuotlar narxlari
        </div>
      </div>

      {!warehouseId || isLoading || isFetching ? (
        <div className='h-[260px] flex items-center justify-center'>
          <CircularProgress size={30} color='inherit' />
        </div>
      ) : isError ? (
        <div className='no-data-found-wrapper h-full'>
          <i className='bi bi-exclamation-octagon text-lg mr-1' /> Ma'lumot
          topilmadi!
        </div>
      ) : (
        <Grid
          container
          spacing={2}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        >
          <Grid item={true} lg={12} md={12} sm={12} xs={12}>
            <div className='shadow-md p-2 border rounded-md w-full h-full'>
              <div className='p-2 border shadow-md mt-2'>
                UZS:{' '}
                <CurrencyFormat
                  value={data?.summary?.sum}
                  suffix=''
                  decimalScale={2}
                />
              </div>
              <div className='p-2 border shadow-md mt-2'>
                USD:{' '}
                <CurrencyFormat
                  value={data?.summary?.valute}
                  suffix=''
                  decimalScale={2}
                />
              </div>
            </div>
          </Grid>
          <Grid item={true} lg={12} md={12} sm={12} xs={12}>
            <div className='shadow-md p-2 border rounded-md w-full h-full'>
              <Accordion
                sx={{
                  boxShadow: 'none',
                }}
                className='client-accordion'
              >
                <AccordionSummary
                  expandIcon={<i className='bi bi-chevron-right expand-icon' />}
                  className='client-accordion-summary !shadow-md !base-border'
                >
                  <div className='client-data'>
                    <div className='client-data-header px-2'>
                      <div className='client-data-title'>
                        <div className='client-name'>
                          Ombordagi mahsulotlar ro'yxati
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails className='client-accordion-details'>
                  <div className='client-contracts-wrapper  h-[calc(100vh-420px)]'>
                    <TableContainer className='flex-auto w-full h-full !shadow-none !base-border'>
                      <Table
                        stickyHeader
                        sx={{ width: 'inherit' }}
                        aria-labelledby='tableTitle'
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell className='!bg-gray-50'>№</TableCell>
                            <TableCell className='!bg-gray-50'>Nomi</TableCell>
                            <TableCell className='!bg-gray-50'>
                              Kategoriya
                            </TableCell>
                            <TableCell className='!bg-gray-50'>
                              Birlik
                            </TableCell>
                            <TableCell className='!bg-gray-50'>
                              Miqdor
                            </TableCell>
                            <TableCell className='!bg-gray-50'>
                              Sum(UZS)
                            </TableCell>
                            <TableCell className='!bg-gray-50'>
                              Valyuta(USD)
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody className='overflow-hidden'>
                          {data?.products?.map((row, rowIndex) => (
                            <TableRow
                              hover
                              tabIndex={-1}
                              key={'row-' + rowIndex}
                            >
                              <TableCell>{rowIndex + 1}</TableCell>
                              <TableCell>{row?.name}</TableCell>
                              <TableCell>{row?.category}</TableCell>
                              <TableCell>{row?.unit}</TableCell>
                              <TableCell>
                                <CurrencyFormat
                                  value={row?.total_amount}
                                  suffix={''}
                                />
                              </TableCell>
                              <TableCell>
                                <CurrencyFormat
                                  value={row?.total_sum_uzs}
                                  suffix={' UZS'}
                                />
                              </TableCell>
                              <TableCell>
                                <CurrencyFormat
                                  value={row?.total_valute_usd}
                                  suffix={' USD'}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default memo(ProductStatistics);
